import { useQuery } from '@tanstack/react-query';
import { fetchAdminIssueStoreLabels } from '../api/adminIssuesApi';

export const adminIssueStoreLabelsQueryKey = (serviceDeskId: number, ids: string[]) => [
  'adminIssueStoreLabels',
  serviceDeskId,
  ids,
];

// Stable identity: a fresh object would remap every row on each render.
const NO_LABELS: Record<string, string> = {};

/**
 * The store names of the listed page, fetched after it rather than with it: Jira hands the
 * tickets back in ~1s and Assets takes ~0.5s more to name the stores. The ids are the cache
 * key, so a page already seen names its stores with no request at all.
 */
export const useAdminIssueStoreLabels = (serviceDeskId: number, ids: string[]) => {
  const { data, isLoading } = useQuery({
    queryKey: adminIssueStoreLabelsQueryKey(serviceDeskId, ids),
    queryFn: () => fetchAdminIssueStoreLabels(serviceDeskId, ids),
    enabled: !!serviceDeskId && ids.length > 0,
    staleTime: 10 * 60 * 1000,
  });

  return { labels: data ?? NO_LABELS, isLoading: isLoading && ids.length > 0 };
};
